export default __webpack_public_path__ + "static/media/ToyotaType-Semibold.9c04343b.woff2";